import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { KioskModeService } from '../../services/kiosk-mode.service';
import { UserService } from '../../services/user.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastService, ToastState } from '../../services/toast.service';
import { StorageKeys, StorageService } from '../../services/storage.service';

@Component({
	selector: 'app-kiosk-settings',
	templateUrl: './kiosk-settings.component.html',
	styleUrls: ['./kiosk-settings.component.scss'],
})
export class KioskSettingsComponent implements OnInit {
	form: UntypedFormGroup;
	idSetup = false;
	validCheck = true;

	constructor(
		private kioskModeService: KioskModeService,
		private fb: UntypedFormBuilder,
		private userService: UserService,
		private router: Router,
		private toast: ToastService,
		private storage: StorageService
	) {}

	ngOnInit(): void {
		this.setForceRefresh();
		this.userService.getStatusOfIDNumber().subscribe({
			next: (result) => {
				this.idSetup = result.results?.setup;
			},
		});
		this.form = this.fb.group(this.kioskModeService.getKioskModeSettings());
		this.validCheck = this.kioskModeService.kioskSettingsValidCheck();
		this.form.valueChanges.subscribe((value) => {
			if (this.idSetup) {
				this.kioskModeService.setKioskModeSettings(this.form.value);
				this.validCheck = this.kioskModeService.kioskSettingsValidCheck();
			}
		});
	}

	private setForceRefresh(): void {
		// the only time the user reaches this page is right before entering kiosk mode.
		// We want to force refresh the page when the user enters kiosk mode, whether
		// the user comes from the teacher home page, or a dedicated login.
		// This localstorage date is intended to be consumed in the KioskModeComponent
		this.storage.setItem(StorageKeys.kioskModeForceRefresh, 'true');
	}

	enterKioskMode() {
		if (this.kioskModeService.kioskSettingsValidCheck()) {
			this.kioskModeService.loginAsKiosk().subscribe({
				next: () => {
					this.kioskModeService.setTempAsCurrentRoom();
					this.router.navigate(['main/kioskMode']);
				},
				error: (err: Error) => {
					if (err instanceof HttpErrorResponse) {
						if (err.status === 401 && err.error.detail === 'cannot enter kiosk for unassigned room') {
							this.toast.openToast({
								title: 'Cannot enter Kiosk Mode!',
								subtitle: 'There are no teachers assigned to this room! Contact your admin for more information',
								type: ToastState.Error,
							});
							this.router.navigate(['main/passes']);
						}
					}
				},
			});
		}
	}

	control(id: string): UntypedFormGroup {
		return this.form.get(id) as UntypedFormGroup;
	}
}
